export default __webpack_public_path__ + "static/media/cloudeve.6eacb274.jpg";